import angular from 'angular'
import taxDeclarationCalendar from './view/taxDeclarationCalendar.html'

class taxDeclarationCalendarComponent {
  constructor(
    httpRequest,
    sweetalert,
    $timeout,
    $rootScope,
    logger,
    Upload,
    $uibModal
  ) {
    const scope = this
    scope.userType = $rootScope.userInfo.user.userType
    scope.selectedRows = []
    scope.importBtnCollapsed = false
    scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        applyPeriod: '',
      },
    }
    // 字典
    const typecodeArrStr = [
      'zzs_reportingPeriod',
      'zzs_status',
      'calendar_status',
    ]
    scope.dictionary = {}
    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
      scope.dictData = $.extend(scope.dictionary, res.data.value)
    })
    scope.tableDropdownConfig = [
      {
        label: '禁用',
        handler(item) {
          const params = {
            id: item.id,
            status: 1,
          }
          disableEnable(params, '禁用')
        },
        showWhile(item, hasPermit) {
          return scope.userType == 0 && item.status == 0 ? true : false
        },
      },
      {
        label: '启用',
        handler(item) {
          const params = {
            id: item.id,
            status: 0,
          }
          disableEnable(params, '启用')
        },
        showWhile(item, hasPermit) {
          return scope.userType == 0 && item.status == 1 ? true : false
        },
      },
    ]
    // 禁用启用
    function disableEnable(params, tipMsg) {
      sweetalert.confirm(`${tipMsg}提醒`, `确认${tipMsg}此信息`).then(() => {
        httpRequest
          .get_updateStatusById(params, `${tipMsg}成功！`)
          .then((res) => {
            scope.queryList()
          })
      })
    }
    scope.reset = function () {
      scope.queryParam.param = {
        applyPeriod: '',
      }
    }
    // scope.reset()
    scope.queryList = function queryList() {
      httpRequest.post_getRpaLogList(scope.queryParam).then((res) => {
        scope.listData = res.data.value.list
        scope.totalItems = res.data.value.total
        scope.queryParam.pageNum = res.data.value.pageNum
      })
    }
    scope.queryList()
    scope.importconfig = {
      code: 'SWKJKM',
      validate: {
        pattern: '.xlsx,.xls',
        _validate: {
          size: { min: 10, max: '10MB' },
          duration: { min: '10s', max: '5m' },
          accept: '.xlsx,.xls',
        },
      },
      appName: host.etcloudSb,
      hideDownload: true,
      callback() {
        scope.queryList()
      },
    }
    // 导入
    scope.uploadFiles = function uploadFiles(file, errFiles) {
      if (file == null && errFiles.length >= 1) {
        logger.logError(
          '文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入'
        )
        return
      }
      if (file) {
        file.upload = Upload.upload({
          url: `${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/importBill`,
          data: {
            importFile: file,
            code: 'CALENDAR_IMPORT',
          },
        })
        // 文件上传
        // loading动画
        const importinglayer = layer.msg('玩命上传中，请耐心等待', {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        })
        file.upload.then(
          (res) => {
            $timeout(() => {
              if (!res.data.success) {
                layer.close(importinglayer)
                return logger.logError(res.data.message || '上传失败')
              }
              if (res.data.value.sourceCount === 0) {
                layer.close(importinglayer)
                return logger.logTips('导入数据为空！', 'warn')
              }
              const { batchNo, sourceCount, errorCount } = res.data.value
              // 结果弹框
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: 1,
                  pageSize: 10,
                  param: res.data.value.batchNo,
                })
                .then((res1) => {
                  layer.close(importinglayer)
                  scope.importResultModal({
                    batchNo,
                    sourceCount,
                    successCount: sourceCount - errorCount,
                    errorCount,
                    data: res1.data.value,
                  })
                  scope.queryList()
                })
            })
          },
          (response) => {}
        )
      }
    }
    // 导入结果弹窗
    scope.importResultModal = function (modalData) {
      const modalInstance = $uibModal.open({
        templateUrl: 'importResult.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.modalData = items1
            $scope.list = items1.data.list
            console.log($scope.modalData)
            $scope.pageOptions = {
              // 分页器
              totalItems: $scope.modalData.data.total,
              currentPage: ++$scope.modalData.data.prePage,
              maxSize: $scope.modalData.data.pageSize,
            }
            // 关闭
            $scope.ok = () => {
              $uibModalInstance.close()
            }
            // 分页查询
            $scope.pageChanged = () => {
              queryList()
            }
            function queryList() {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: scope.pageOptions.currentPage,
                  pageSize: scope.pageOptions.maxSize,
                  param: scope.modalData.batchNo,
                })
                .then((res) => {
                  scope.list = res.data.value.list
                  scope.pageOptions = {
                    // 分页器
                    totalItems: res.data.value.total,
                    currentPage: ++res.data.value.prePage,
                    maxSize: res.data.value.pageSize,
                  }
                })
            }
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal-importexcel',
        windowClass: 'mod-modal mod-modal-lg',
        bindToController: true,
        resolve: {
          items1() {
            return modalData
          },
        },
      })
      modalInstance.result.then(
        () => {},
        () => {}
      )
    }
    // 模板下载
    scope.downloadExcel = function () {
      window.open(
        `${
          host.etcloudIvatApp
        }taxdeclaration/rpaGsConfig/exportRpaGsConfigTemple?code=CALENDAR_NOTIMPORT&accessToken=${localStorage.getItem(
          'id_token'
        )}`
      )
    }
    // 表头排序
    scope.orderMap = { sortKey: '', sortVal: '' }
    scope.selectedHandle = function selectedHandle() {
      scope.queryParam.orderMap = {}
      if (scope.orderMap.sortKey)
        scope.queryParam.orderMap[scope.orderMap.sortKey] =
          scope.orderMap.sortVal
      scope.queryList()
    }
    // 导出
    scope.exportTaxClass = function exportTaxClass() {
      httpRequest.get_exportSbKjkmDmToExcel(scope.queryParam.param)
    }
  }
}
taxDeclarationCalendarComponent.$inject = [
  'httpRequest',
  'sweetalert',
  '$timeout',
  '$rootScope',
  'logger',
  'Upload',
  '$uibModal',
]
export default angular
  .module('system.basedata.taxPolicy.taxDeclarationCalendar', [])
  .controller(
    'taxDeclarationCalendarComponent',
    taxDeclarationCalendarComponent
  )
  .component('taxDeclarationCalendar', {
    controller: 'taxDeclarationCalendarComponent',
    template: taxDeclarationCalendar,
  }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxClass/taxDeclarationCalendarComponent.js